import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';

export default class GoogleService {

    initCalendar(accessToken) {
        this.accessToken = accessToken;
    }

    getCalendars() {
        return axios.get(`https://www.googleapis.com/calendar/v3/users/me/calendarList?access_token=${this.accessToken}`)
            .then(calendars => {
                const calendarMap = _.map(calendars.data.items, ({ summary, id }) => ({ summary, id }));
                return Promise.resolve(calendarMap);
            })
            .catch(error => Promise.reject(error));
    }

    getColors() {
        return axios.get(`https://www.googleapis.com/calendar/v3/colors?fields=event&access_token=${this.accessToken}`)
            .then(response => Promise.resolve(response.data.event))
            .catch(error => Promise.reject(error));
    }

    async getEvents(calendarId) {
        const colors = await this.getColors();

        const start = moment().startOf('day').format() // 2019-02-21T00%3A00%3A00-08%3A00;
        const end = moment().endOf('day').format(); // 2019-02-22T00%3A00%3A00-08%3A00
        try {
            const response = await axios.get(`https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?timeMax=${end}&timeMin=${start}&fields=items(colorId%2Cend%2Cstart%2Csummary)&access_token=${this.accessToken}`)
            response.data.items.forEach(event => {
                event.color = _.get(colors[event.colorId], 'background');
            });

            return _.sortBy(response.data.items, o => o.start.dateTime);
        } catch (error) {
            Promise.reject(error)
        }
    }
}